module.exports = __webpack_public_path__ + "49bacd5ab9e67de0386fb493f9d570e9.MP3";